module.exports = __webpack_public_path__ + "static/testcontactbg-a10b0689809951c05339c296a7c29449.jpg";